import { Col, Row, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useNotificationLogs } from '@/entities/report/api/hooks';
import type { NotificationLog } from '@/entities/report/model/reportSchema';
import type { Status } from '@/entities/user/model/userSchema';
import { StatusBadge } from '@/shared/ui/StatusBadge';
import { antTablePagination, antTableScroll } from '@/shared/constants/antTable';
import { NotificationRulesCard } from './NotificationRulesCard';
import s from './NotificationsTab.module.scss';

const logColumns: ColumnsType<NotificationLog> = [
  { title: 'Дата', dataIndex: 'date', key: 'date' },
  { title: 'Событие', dataIndex: 'event', key: 'event' },
  { title: 'Адресат', dataIndex: 'recipient', key: 'recipient' },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (st: Status) => <StatusBadge status={st} label={st === 'ok' ? 'Доставлено' : 'Ошибка SMTP'} />,
  },
];

export function NotificationsTab() {
  const { data: logs, isLoading: logsLoading } = useNotificationLogs();

  return (
    <Row gutter={[14, 14]}>
      <Col xs={24}>
        <NotificationRulesCard />
      </Col>
      <Col xs={24}>
        <div className={s.root__section}>
          <div className={s.root__table_title}>Журнал уведомлений</div>
          <Table
            loading={logsLoading}
            dataSource={logs}
            columns={logColumns}
            rowKey="id"
            size="small"
            pagination={{ ...antTablePagination }}
            scroll={antTableScroll}
          />
        </div>
      </Col>
    </Row>
  );
}
